<tt-page>
    <tt-order-pick-new [params]="params" (submit)="onSubmit($event)"></tt-order-pick-new>
</tt-page>
